import { render, staticRenderFns } from "./TowerTag.vue?vue&type=template&id=63f9b099&scoped=true&"
import script from "./TowerTag.vue?vue&type=script&lang=js&"
export * from "./TowerTag.vue?vue&type=script&lang=js&"
import style0 from "./TowerTag.vue?vue&type=style&index=0&id=63f9b099&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9b099",
  null
  
)

export default component.exports